// hooks
import { useLocalStorage } from "src/hooks/use-local-storage";

//
import { useCallback, useMemo } from "react";
import { SettingsValueProps } from "../types";
import { SettingsContext } from "./settings-context";

// ----------------------------------------------------------------------

type SettingsProviderProps = {
  children: React.ReactNode;
  defaultSettings: SettingsValueProps;
};

export function SettingsProvider({
  children,
  defaultSettings,
}: SettingsProviderProps) {
  const [settings, setSettings] = useLocalStorage("settings", defaultSettings);

  const onUpdate = useCallback(
    (name: string, value: string | boolean) => {
      setSettings((prevState: SettingsValueProps) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [setSettings],
  );

  const memoizedValue = useMemo(
    () => ({
      ...settings,
      onUpdate,
    }),
    [settings, onUpdate],
  );

  return (
    <SettingsContext.Provider value={memoizedValue}>
      {children}
    </SettingsContext.Provider>
  );
}
